//core
import React from "react";
import CopyToClipboard from 'react-copy-to-clipboard';
import { IconButton } from "@mui/material";

//icons
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

//hooks
import { useUI } from "../../../store/common/ui/useUI";

interface ICopyToClipboardButtonProps {
  text: string;
  className?: string;
}

const CopyToClipboardButton: React.FC<ICopyToClipboardButtonProps> = ({
  text,
  className,
}): JSX.Element => {
  const { setGeneralSnackbar } = useUI();

  const handleCopyCode = () => {
    setGeneralSnackbar({
      open: true,
      type: 'success',
      message: 'success',
      messageKey: 'common.messages.copied',
    })
  };

  return (
    <>
      <CopyToClipboard onCopy={handleCopyCode} text={text}>
        <IconButton
          className={className}
          aria-label="copy"
          size="small"
          sx={{ padding: '4px' }}
        >
          <ContentCopyIcon fontSize="small" />
        </IconButton>
      </CopyToClipboard>
    </>
  );
};

export default CopyToClipboardButton;
